export enum EReportPromptType {
  lens = 'lens',
  entityFiscalYearStart = 'entityFiscalYearStart',
  coaSegmentDesignation = 'coaSegmentDesignation',
  relativeDateFilter = 'relativeDateFilter',
  featureFlag = 'featureFlag'
}

export interface IBaseReportPrompt {
  type: EReportPromptType;
}

export interface IReportPromptUserSelected extends IBaseReportPrompt {
  outputVars: string | string[];
}

export enum EReportPromptDesignationType {
  code = 'code',
  description = 'description',
  displayDelegate = 'displayDelegate'
}

// what should the outcome affect?
export enum EReportPromptConfigurationTarget {
  organizedBy = 'organizedBy',
  categorizedBy = 'categorizedBy',
  show = 'show'
}

export enum EReportSegmentUrns {
  fundCode = 'urn:opengov:types/semantic/accounting/coa/fund-code',
  departmentCode = 'urn:opengov:types/semantic/accounting/coa/department-code',
  accountNumber = 'urn:opengov:types/semantic/accounting/coa/account-number',
  accountNumberId = 'urn:opengov:types/semantic/accounting/coa/account-number-id',
  accountNumberEbto = 'urn:opengov:types/semantic/accounting/coa/account-number-ebto',
  displayDelegate = 'urn:opengov:types/semantic/display-delegate',
  accountType = 'urn:opengov:types/semantic/accounting/coa/account-type'
}

export interface IReportPromptFeatureFlag extends IBaseReportPrompt {
  flag: string;
}

export interface IReportPromptDesignation extends IBaseReportPrompt {
  type: EReportPromptType.coaSegmentDesignation;
  segmentUrn: EReportSegmentUrns;
  designationType: EReportPromptDesignationType;
  target: EReportPromptConfigurationTarget;
  appliesToSavedViews: string[]; // saved view ids within the template
}

export interface IReportPromptRelativeDateFilter extends IBaseReportPrompt {
  type: EReportPromptType.relativeDateFilter;
  column: string;
  daysToFilter: number;
  appliesToSavedViews: string[]; // saved view ids within the template
}

export type IReportPrompt =
  | IBaseReportPrompt
  | IReportPromptUserSelected
  | IReportPromptDesignation
  | IReportPromptFeatureFlag
  | IReportPromptRelativeDateFilter;

export const isReportPromptUserSelected = (prompt: any): prompt is IReportPromptUserSelected =>
  prompt.outputVars !== undefined;

export const isReportPromptNotUserSelected = (prompt: any): prompt is IBaseReportPrompt =>
  prompt.outputVars === undefined;
